import { useState, useCallback, useEffect } from 'react';
export const useResizable = ({ position, setPosition, size, setSize, isMaximized })=>{
    const [isResizing, setIsResizing] = useState(false);
    const [resizeStart, setResizeStart] = useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        direction: '',
        startX: 0,
        startY: 0
    });
    // 리사이즈 시작
    const handleResizeStart = useCallback((e, direction)=>{
        if (isMaximized) return;
        e.stopPropagation();
        e.preventDefault();
        let clientX;
        let clientY;
        if ('touches' in e && e.touches.length > 0) {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
        } else if ('clientX' in e) {
            clientX = e.clientX;
            clientY = e.clientY;
        } else {
            return;
        }
        setIsResizing(true);
        setResizeStart({
            x: clientX,
            y: clientY,
            width: size.width,
            height: size.height,
            direction,
            startX: position.x,
            startY: position.y
        });
    }, [
        size,
        position,
        isMaximized
    ]);
    // 리사이즈 처리
    useEffect(()=>{
        const handleMouseMove = (e)=>{
            if (isResizing && !isMaximized) {
                const deltaX = e.clientX - resizeStart.x;
                const deltaY = e.clientY - resizeStart.y;
                let newWidth = resizeStart.width;
                let newHeight = resizeStart.height;
                let newX = resizeStart.startX;
                let newY = resizeStart.startY;
                if (resizeStart.direction.includes('e')) newWidth = resizeStart.width + deltaX;
                if (resizeStart.direction.includes('w')) {
                    newWidth = resizeStart.width - deltaX;
                    newX = resizeStart.startX + deltaX;
                }
                if (resizeStart.direction.includes('s')) newHeight = resizeStart.height + deltaY;
                if (resizeStart.direction.includes('n')) {
                    newHeight = resizeStart.height - deltaY;
                    newY = resizeStart.startY + deltaY;
                }
                const minWidth = 300;
                const minHeight = 250;
                if (newWidth < minWidth) {
                    newWidth = minWidth;
                    if (resizeStart.direction.includes('w')) newX = resizeStart.startX + resizeStart.width - minWidth;
                }
                if (newHeight < minHeight) {
                    newHeight = minHeight;
                    if (resizeStart.direction.includes('n')) newY = resizeStart.startY + resizeStart.height - minHeight;
                }
                const maxWidth = window.innerWidth - 20;
                const maxHeight = window.innerHeight - 20;
                if (newWidth > maxWidth) newWidth = maxWidth;
                if (newHeight > maxHeight) newHeight = maxHeight;
                setSize({
                    width: newWidth,
                    height: newHeight
                });
                setPosition({
                    x: newX,
                    y: newY
                });
            }
        };
        const handleTouchMove = (e)=>{
            if (isResizing && e.touches.length === 1 && !isMaximized) {
                const touch = e.touches[0];
                const deltaX = touch.clientX - resizeStart.x;
                const deltaY = touch.clientY - resizeStart.y;
                let newWidth = resizeStart.width;
                let newHeight = resizeStart.height;
                let newX = resizeStart.startX;
                let newY = resizeStart.startY;
                if (resizeStart.direction.includes('e')) newWidth = resizeStart.width + deltaX;
                if (resizeStart.direction.includes('w')) {
                    newWidth = resizeStart.width - deltaX;
                    newX = resizeStart.startX + deltaX;
                }
                if (resizeStart.direction.includes('s')) newHeight = resizeStart.height + deltaY;
                if (resizeStart.direction.includes('n')) {
                    newHeight = resizeStart.height - deltaY;
                    newY = resizeStart.startY + deltaY;
                }
                const minWidth = 300;
                const minHeight = 250;
                if (newWidth < minWidth) {
                    newWidth = minWidth;
                    if (resizeStart.direction.includes('w')) newX = resizeStart.startX + resizeStart.width - minWidth;
                }
                if (newHeight < minHeight) {
                    newHeight = minHeight;
                    if (resizeStart.direction.includes('n')) newY = resizeStart.startY + resizeStart.height - minHeight;
                }
                const maxWidth = window.innerWidth - 20;
                const maxHeight = window.innerHeight - 20;
                if (newWidth > maxWidth) newWidth = maxWidth;
                if (newHeight > maxHeight) newHeight = maxHeight;
                setSize({
                    width: newWidth,
                    height: newHeight
                });
                setPosition({
                    x: newX,
                    y: newY
                });
            }
        };
        const handleMouseUp = ()=>{
            setIsResizing(false);
        };
        const handleTouchEnd = ()=>{
            setIsResizing(false);
        };
        if (isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('touchmove', handleTouchMove, {
                passive: false
            });
            document.addEventListener('mouseup', handleMouseUp);
            document.addEventListener('touchend', handleTouchEnd);
        }
        return ()=>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('touchend', handleTouchEnd);
        };
    }, [
        isResizing,
        resizeStart,
        isMaximized,
        setPosition,
        setSize
    ]);
    return {
        isResizing,
        handleResizeStart
    };
};
